import { createFileRoute, redirect } from "@tanstack/react-router";

import { PeopleDirectoryPage } from "@/components/pages/PeopleDirectoryPage";
import { env } from "@/config/env";

/** While the People Hub is switched off, the old Configure → Staff list is the live page. */
export const Route = createFileRoute("/_authenticated/people/")({
  beforeLoad: () => {
    if (!env.VITE_PEOPLE_HUB_ENABLED) {
      throw redirect({ to: "/settings/staff" });
    }
  },
  component: PeopleDirectoryPage,
});
